import React from 'react'; 
import { Link } from 'react-router-dom';
import FadeIn from "react-lazyload-fadein";
import ArticleText from './ArticleText';
import ArticleImage from './ArticleImage';
import ArticleGallery from './ArticleGallery';
import ArticleVideo from './ArticleVideo';
import ArticleAudio from './ArticleAudio';
import WithConsumer from '../../context/WithConsumer';
import Foot from '../global/Foot';

const Article = ({ context }) => {

	let results = '';
		 
    const posts = () => context.posts;
    const post = posts()[0];
            
    if (post) {
	    
	    let pageClass = 'c-page-wrapper c-page c-page-' + post.slug + 'c-article';
		
		if (context.appError){
		
			return null; 
		
		} else if (post.block) {
			
			document.documentElement.classList.remove('state-reverse-header');
			document.documentElement.classList.add('state-minimal-header');
			document.documentElement.classList.remove('scope-reverse');
			
			const blocks = post.block; 
			
			let pageBlocks = null;
										
			if (blocks.length > 0){
								
				pageBlocks = blocks.map(function(block,i){
					
					if (block.type === 'text') {
						return <ArticleText key={i} index={i} block={block}></ArticleText>
					} else if (block.type === 'image') {
						return <ArticleImage key={i} index={i} block={block}></ArticleImage>
					} else if (block.type === 'gallery') {
						return <ArticleGallery key={i} index={i} block={block}></ArticleGallery>
					} else if (block.type === 'video') {
						return <ArticleVideo key={i} index={i} block={block}></ArticleVideo>
					} else if (block.type === 'audio') {
						return <ArticleAudio key={i} index={i} block={block}></ArticleAudio>
					}
					
				})
				
			}
							
			return (
				<>

					<div className={pageClass}>
						
						<div className="c-page__inner">
						
							<div className="c-page__block c-page__block--l-space c-page__block--load-effect">
							
								<div className="l-content l-content--fixed-width">
									
									<div className="l-grid">
										
										<div className="l-grid__col">
										
											<h3 className="c-paragraph c-paragraph--xxxlarge" dangerouslySetInnerHTML={{__html:post.type}}></h3>
										
										</div>
										
									</div>
									
								</div>
								
							</div>
						
							<div className="c-page__block c-page__block--l-space c-page__block--load-effect">
						
								<div className="l-content l-content--fixed-width">
									
									<div className="l-grid">
										
										<div className="l-grid__col l-grid__col--m-6-12">
											
											<header>
												{post.author_name &&
													<h3 className="c-paragraph"><Link to={post.author_link} dangerouslySetInnerHTML={{__html:post.author_name}}></Link></h3>
												}
												{post.heading &&
													<h1 className="c-paragraph c-paragraph--faded c-paragraph--space" dangerouslySetInnerHTML={{__html:post.heading}}></h1>
												}
												{post.date &&
													<h5 className="c-paragraph c-paragraph--faded c-paragraph--l-space" dangerouslySetInnerHTML={{__html:post.date}}></h5>
												}
											</header>
																						
										</div>
										
										<div className="l-grid__col l-grid__col--m-6-12">
											
											{pageBlocks}
																						
										</div>
										
									</div>
						
								</div>
							
							</div>
							
							<Foot></Foot>
															
						</div>
						
					</div>
					
				</>
			)
						
		} else {
			
			return null;
			
		}

	} else {
		
		return null;
	
	}
};
export default WithConsumer(Article);